export default __webpack_public_path__ + "static/media/tuzla-kart-nerelerde-kullanılır.11cd7748.JPG";